module.exports = __webpack_public_path__ + "static/media/L.ced6d175.jpg";